import { render } from "./Text.vue?vue&type=template&id=61d43bb6"
import script from "./Text.vue?vue&type=script&lang=js"
export * from "./Text.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2026.5.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__